import carouselExtDotCtrl from './carouselExtDot.ctrl.js';

export const carouselExtDotComponent = {
    require: {
        carouselExtRoot: '^carouselExtRoot',
    },
    controller: carouselExtDotCtrl,
    bindings: {},
};
